/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  call,
  put,
  takeEvery,
  takeLatest,
  take,
  cancel,
  delay
} from 'redux-saga/effects'
import {
  FETCH_PROBES,
  POLL_PROBES_START,
  POLL_PROBES_STOP,
} from './actionTypes'
import { fetchProbesSuccess, fetchProbesFailure } from './actions'
import { ProbesList } from './probesList'
// worker Saga: will be fired on REQUEST_HUBS actions
function* fetchProbespoll(params) {

  try {
    const response = yield call(ProbesList.fetchProbeDetails, params)
    yield put(fetchProbesSuccess(response.data))
  } catch (error) {
    yield put(fetchProbesFailure(error))
  }
}

function* pollProbes(action) {
  while (true) {
    yield delay(30000)
    yield call(fetchProbespoll,  {count:action.count,useEnhancedflag: action.useEnhancedflag ,categories:action.categories})
  }
}

/*
  Starts fetchHubs on each dispatched `REQUEST_HUBS` action.
  Allows concurrent fetches of user.
*/
export function* probesRequestSaga() {
  yield takeEvery(FETCH_PROBES, fetchProbespoll,{count:false,useEnhancedflag: false ,categories:'NON_LOCAL'})
}

export function* probesPollingSaga() {
  while (true) {
    const watcherInstance = yield takeLatest(POLL_PROBES_START, pollProbes)
    // cancel polling on POLL_HUBS_STOP
    yield take(POLL_PROBES_STOP)
    yield cancel(watcherInstance)
  }
}
